import { titleCase } from "../../../helper";
import {
  BoxTab,
  BoxTabEach,
  TabHeader,
  TabSub,
} from "../../../pages/YachtClubViewDetails";

interface VisitDetailsprops {
  visitDate: string;
  visitTime: string;
  userPackage: string;
  modeOfPayment: string;
}
const VisitDetails = ({
  visitDate,
  visitTime,
  userPackage,
  modeOfPayment,
}: VisitDetailsprops) => {
  return (
    <BoxTab>
      <BoxTabEach>
        <TabHeader>Visit Date</TabHeader>
        <TabSub>{visitDate}</TabSub>
      </BoxTabEach>
      <BoxTabEach>
        <TabHeader>Visit Time</TabHeader>
        <TabSub>{visitTime}</TabSub>
      </BoxTabEach>
      <BoxTabEach>
        <TabHeader>Package</TabHeader>
        <TabSub>
          {userPackage === "dropOrPickUp"
            ? "DropOff/PickUp"
            : titleCase(userPackage)}
        </TabSub>
      </BoxTabEach>
      <BoxTabEach>
        <TabHeader>Mode Of Payment</TabHeader>
        <TabSub>{titleCase(modeOfPayment)}</TabSub>
      </BoxTabEach>
    </BoxTab>
  );
};

export default VisitDetails;
